export interface Sort<T = object, P extends keyof T = never, V extends T[P] = never> {
  property: P;
  direction: 'asc' | 'desc';
  comparator?: (o: V, p: V) => number;
}
